import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
import { apiClient } from "../../api/client";
import { getCharacterPortraitSrc } from "../../utils/helpers";

const PLACEHOLDER_AVATAR = "/media/shield_kadia_02.png";

const AdminDashboardPage = () => {
    const navigate = useNavigate();
    const [applications, setApplications] = useState([]);
    const apiUrl = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const fetchData = async () => {
            try {
                const result = await apiClient.post(
                    `${apiUrl}api/acp/get-applications`,
                );
                setApplications(Array.isArray(result) ? result : []);
            } catch (err) {
                console.error(err.message);
                setApplications([]);
            }
        };
        fetchData();
    }, [apiUrl]);

    const openApplication = (characterId) => {
        navigate(`/acp/character?id=${characterId}`);
    };

    const avatarForRow = (application) =>
        getCharacterPortraitSrc(application);

    return (
        <div className="admin-page admin-dashboard">
            <SimpleBar className="admin-dashboard-simplebar">
                <div className="admin-table">
                    <table>
                        <thead>
                            <tr>
                                <th className="admin-table__col-avatar"></th>
                                <th>ИМЯ ПЕРСОНАЖА</th>
                                <th>UCP</th>
                                <th>СТАТУС</th>
                            </tr>
                        </thead>
                        <tbody>
                            {applications.length === 0 ? (
                                <tr className="admin-table__empty">
                                    <td colSpan={4}>Нет заявок</td>
                                </tr>
                            ) : (
                                applications.map((application) => (
                                    <tr
                                        key={application.character_id}
                                        className="admin-table__row"
                                        tabIndex={0}
                                        role="button"
                                        onClick={() =>
                                            openApplication(
                                                application.character_id,
                                            )
                                        }
                                        onKeyDown={(e) => {
                                            if (
                                                e.key === "Enter" ||
                                                e.key === " "
                                            ) {
                                                e.preventDefault();
                                                openApplication(
                                                    application.character_id,
                                                );
                                            }
                                        }}
                                    >
                                        <td className="admin-table__cell-avatar">
                                            <img
                                                src={avatarForRow(application)}
                                                alt=""
                                                className="admin-table__avatar"
                                                draggable={false}
                                                onError={(e) => {
                                                    e.currentTarget.src =
                                                        PLACEHOLDER_AVATAR;
                                                }}
                                            />
                                        </td>
                                        <td>{application.character_name}</td>
                                        <td>{application.character_login}</td>
                                        <td>
                                            {String(
                                                application.character_status ||
                                                    "",
                                            ).toUpperCase()}
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </SimpleBar>
        </div>
    );
};

export default AdminDashboardPage;
